module.exports = __webpack_public_path__ + "static/lights13-0e57737b24c52f4995e3ed8d4fd7dffc.jpg";